import React, { createContext, useContext, useEffect, useMemo } from 'react';

import { darkTheme, type AppTheme } from './index';
import * as platform from '../utils/platform';

const LEGACY_STORAGE_KEY = 'app.theme.mode';

export type ThemeModeContextValue = {
  theme: AppTheme;
};

const ThemeModeCtx = createContext<ThemeModeContextValue | null>(null);

type AppThemeProviderProps = {
  children: React.ReactNode;
};

export const AppThemeProvider: React.FC<AppThemeProviderProps> = ({ children }) => {
  useEffect(() => {
    void platform.storage.removeItem(LEGACY_STORAGE_KEY);
  }, []);

  const ctx = useMemo(() => ({ theme: darkTheme }), []);

  return <ThemeModeCtx.Provider value={ctx}>{children}</ThemeModeCtx.Provider>;
};

export function useThemeMode(): ThemeModeContextValue {
  const v = useContext(ThemeModeCtx);
  if (!v) {
    throw new Error('useThemeMode must be used within AppThemeProvider');
  }
  return v;
}

export function useAppTheme(): AppTheme {
  return useThemeMode().theme;
}
